module.exports = __webpack_public_path__ + "static/media/PaulAweleNti.a9a672bc.jpeg";